//App.Common.Functions.Util
export class Util {
    static findInParents(element: HTMLElement, selectors: string): HTMLElement {
        if (element.matches(selectors)) {
            return element;
        }
        if (element.parentElement == null) {
            throw "Parent not found";
        }
        return Util.findInParents(element.parentElement, selectors);
    }
}